export default {
  attendances: [],
};
